export default {
  test: 'Item in English'
}
